import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProfileApi } from "../../end-points/profile";

const initialState = {
  loading: false,
  error: null,
  success: false,
  tokenData: null,
};

export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (payload, thunkAPI) => {
    try {
      const response = await getProfileApi(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch profile data"
      );
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfileState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.tokenData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.tokenData = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
        state.success = false;
      });
  },
});

export const { clearProfileState } = profileSlice.actions;
export default profileSlice.reducer;